import { render, staticRenderFns } from "./ZonaGuideView.vue?vue&type=template&id=0f4affc1&"
import script from "./ZonaGuideView.vue?vue&type=script&lang=js&"
export * from "./ZonaGuideView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports